// AUTO GENERATED FILE - DO NOT EDIT - GENERATED BY cmd/enterprise/*.go generate authz
export default {
	status: 'success',
	data: {
		resources: [
			{
				kind: 'role',
				type: 'metaresources',
			},
			{
				kind: 'role',
				type: 'role',
			},
			{
				kind: 'serviceaccount',
				type: 'serviceaccount',
			},
		],
		relations: {
			assignee: ['role'],
			attach: ['role', 'serviceaccount'],
			create: ['metaresources'],
			delete: ['role', 'serviceaccount'],
			list: ['metaresources'],
			read: ['role', 'serviceaccount'],
			update: ['role', 'serviceaccount'],
		},
	},
} as const;
